export default "__VITE_ASSET__Cc7WQlH8__"